"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iconsDictionary = {
    sustainability: 'nachhaltigkeit',
    top: 'top',
    luxury: 'luxus',
    'city-holidays': 'stdtereisen',
    'beach-holidays': 'beachholidays',
    hotel_beach_flags: 'beachholidays',
    culture: 'culture',
    'pf-g-kultur-essen-nachtleben': 'culture',
    FR09V: 'culture',
    'beauty-wellness': 'beautywellness',
    hotel_beauty_and_wellness_flags: 'beautywellness',
    'summer-sport': 'sport',
    FR17V: 'sport',
    'pfg-a-sport': 'sport',
    hotel_sports_flags: 'sport',
    nightlife: 'nightlife',
    FR06V: 'nightlife',
    'adults-only': 'adults-only',
    'club-hotel': 'clubhotel',
    'water-sport': 'wassersport',
    FR19V: 'wassersport',
    'free-wifi': 'wlan',
    'winter-sport': 'wintersport',
    'all-inclusive': 'all-inclusive',
    'family-holidays': 'familienferien',
    hotel_family_flags: 'familienferien',
    'national-park': 'nationalpark',
    'CT03-HR16A': 'pets',
    FR23V: 'natur',
    FR13V: 'umgebung',
    hotel_type_flags: 'hotelausstattung',
    hotel_location_flags: 'entfernung',
    'pf-g-umgebung': 'umgebung',
    entertainment: 'unterhaltung',
    gourmet: 'boardtype',
    'pets-allowed': 'pets',
    shopping: 'shopping',
    roundtrip_culture: 'culture',
    roundtrip_nature: 'natur',
    roundtrip_trips: 'excursion',
    cruise_culture: 'culture',
    cruise_nature: 'natur',
    cruise_trips: 'excursion',
    hotel_top: 'top',
    hotel_family: 'familienferien',
    hotel_beach: 'beachholidays',
    hotel_adults: 'adults-only',
    hotel_citytrip: 'stdtereisen',
    hotel_wintersport: 'wintersport',
    hotel_summersport: 'sport',
    hotel_watersport: 'wassersport',
    hotel_wellness: 'beautywellness',
    hotel_entertainment: 'unterhaltung',
    hotel_wlan: 'wlan',
    hotel_gourmet: 'boardtype',
    hotel_sustainable: 'nachhaltigkeit',
    hotel_nationalpark: 'nationalpark',
    hotel_pets: 'pets',
    hotel_luxury: 'luxus',
    hotel_club: 'clubhotel',
    e_car_charging_stations: 'e-car',
    hotel_sustainable_feature_group_name: 'nachhaltigkeit',
    hotel_amenities: 'hotel-amenities',
};
function mapFeatureNameToIcon(featureCode) {
    return iconsDictionary[featureCode] || 'not-found';
}
exports.default = mapFeatureNameToIcon;
//# sourceMappingURL=mapFeatureToIcons.js.map